var React = require('react');

function ProjectsBot (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1440 0H-12C-12 0 1242.5 47 1440 161V0Z","fill":"#F6F6F4"}));
}

ProjectsBot.defaultProps = {"viewBox":"0 0 1440 161","fill":"none"};

module.exports = ProjectsBot;

ProjectsBot.default = ProjectsBot;
